'use client';

import { FaChevronLeft } from 'react-icons/fa6';
import { BiSolidError } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { RiskLevel } from '../../../../types/common.types';

const RiskLabel = ({
  text,
  iconClass,
}: {
  text: string;
  iconClass: string;
}) => (
  <span className={`flex items-center text-neutralText dark:text-neutralBG`}>
    <BiSolidError className={`mr-2.5 ${iconClass}`} />
    {text}
  </span>
);

export const SidebarHeaderRisk = ({
  risk,
  isLoading,
}: {
  risk: RiskLevel;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return (
      <div role="status" className="max-w-sm animate-pulse">
        <Link
          to={'/'}
          className="relative flex h-9 w-10 items-center justify-center rounded-md bg-neutralBG text-neutralText transition duration-100 hover:bg-[#ededed] dark:bg-[#404040] dark:text-neutralBG dark:hover:bg-[#545454] sm:h-8 sm:w-36"
          id="sidebar-back-button"
        >
          <FaChevronLeft className="text-md sm:mr-2" />
          <span className="mr-1 hidden sm:inline-block">Mes fichiers</span>
        </Link>
        <div className="mb-4 mt-4 h-10 w-72 rounded-full bg-gray-200 dark:bg-gray-700 sm:mt-6"></div>
      </div>
    );
  }

  return (
    <div>
      <Link
        to={'/'}
        className="relative flex h-9 w-10 items-center justify-center rounded-md bg-neutralBG text-neutralText transition duration-100 hover:bg-[#ededed] dark:bg-[#404040] dark:text-neutralBG dark:hover:bg-[#545454] sm:h-8 sm:w-36"
        id="sidebar-back-button"
      >
        <FaChevronLeft className="text-md sm:mr-2" />
        <span className="mr-1 hidden sm:inline-block">Mes fichiers</span>
      </Link>
      <div className="mt-4 sm:mt-6">
        <h1 className="flex text-2xl font-medium lg:text-3xl">
          {risk === RiskLevel.VERY_LOW && (
            <RiskLabel
              text="Risque Faible"
              iconClass="dark:text-successText text-[#22a322]"
            />
          )}
          {risk === RiskLevel.LOW && (
            <RiskLabel
              text="Risque Faible"
              iconClass="dark:text-successText text-[#22a322]"
            />
          )}
          {risk === RiskLevel.MEDIUM && (
            <RiskLabel
              text="Risque Moyen"
              iconClass="dark:text-warningText-dark text-[#ef7731]"
            />
          )}
          {risk === RiskLevel.HIGH && (
            <RiskLabel
              text="Risque Élevé"
              iconClass="dark:text-errorText-dark text-[#ec3737]"
            />
          )}
        </h1>
      </div>
    </div>
  );
};
